// https://lincolnprofilev9.cms.dealer.com/2026-lincoln-aviator.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName, widgetId } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer' &&
						widgetId === 'content9'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'vehicle:action:exterior:photo click:exterior',
							onclickLinkName:
								'new:si:vls:content:action:lincoln aviator'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln aviator'
						}
					}
				})
			},
			{
				logic: ({ eventData }) => {
					const { result, widgetName, widgetId } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer' &&
						widgetId === 'content11'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'vehicle:action:interior:photo click:interior',
							onclickLinkName:
								'new:si:vls:content:action:lincoln aviator'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln aviator'
						}
					}
				})
			}
		],
		'ddc.link.generic': [
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'schedule-test-drive'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:schedule test drive',
							onclickLinkName:
								'vehicle:content:action:2026 lincoln aviator'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln aviator'
						}
					}
				})
			},
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'search-inventory'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:search inventory',
							onclickLinkName:
								'new:si:vls:content:action:lincoln aviator'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln aviator'
						}
					}
				})
			}
		]
	}
};
